import { toast, Slide } from 'react-toastify';

// Function to show toast message
export const showToast = (type, message, options = {}) => {
    toast[type](message, {
        position: 'top-right',
        autoClose: 2000,
        draggable: false,
        pauseOnHover: false,
        transition: Slide,
        ...options,
    });
};

export const fnOnChange = (pEvent, pState, pSetState, pErrorState, pSetErrorState) => {
    pSetState({
        ...pState,
        [pEvent.target.name]: pEvent.target.value,
    });
    if (!!pErrorState[pEvent.target.name])
        pSetErrorState({
            ...pErrorState,
            [pEvent.target.name]: null,
        });

    /** New Transaction Details */
    if ((pEvent.target.name === 'payment_date') &&
        (pEvent.target.value !== '' && pEvent.target.value !== undefined) &&
        (pState.payment_plan !== '' && pState.payment_plan !== undefined)) {
        let paymentDate = new Date(pEvent.target.value)
        let paymentDateMonth = paymentDate.getMonth() + 1
        paymentDate.setMonth(paymentDateMonth + parseInt(pState.payment_plan))

        let month = paymentDate.getMonth() + 1
        let date = paymentDate.getDate()
        let expiringDate = `${paymentDate.getFullYear()}-${month < 10 ? '0' + month : month}-${date < 10 ? '0' + date : date}`
        pSetState({
            ...pState,
            [pEvent.target.name]: pEvent.target.value,
            'expiring_date': expiringDate
        });
    }

    if ((pEvent.target.name === 'payment_plan') &&
        (pEvent.target.value !== '' && pEvent.target.value !== undefined) &&
        (pState.payment_date !== '' && pState.payment_date !== undefined)) {
        let paymentDate = new Date(pState.payment_date)
        let paymentDateMonth = paymentDate.getMonth() + 1
        paymentDate.setMonth(paymentDateMonth + parseInt(pEvent.target.value))

        let month = paymentDate.getMonth() + 1
        let date = paymentDate.getDate()
        let expiringDate = `${paymentDate.getFullYear()}-${month < 10 ? '0' + month : month}-${date < 10 ? '0' + date : date}`
        pSetState({
            ...pState,
            [pEvent.target.name]: pEvent.target.value,
            'expiring_date': expiringDate
        });
    }
}
